export default "/images/vendor/flag-icons/flags/1x1/tg.svg?a93a40179b0b03e520bf09436a335599";